import { createStyles, makeStyles, Theme } from '@material-ui/core';
import { themeBackground } from '../../theme/custom-colors';
import { fontFamilies } from '../../theme/fonts';
import { colors } from '../../theme/tokens';

export const drawerWidth = 240;
export const navBackgroundColor = colors.bgNav;
export const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: 'flex',
      height: '100%',
      width: '100%',
    },
    drawer: {
      backgroundColor: navBackgroundColor,
      [theme.breakpoints.up('md')]: {
        width: drawerWidth,
        flexShrink: 0,
      },
    },
    appBar: {
      [theme.breakpoints.up('md')]: {
        width: `calc(100% - ${drawerWidth}px)`,
        marginLeft: drawerWidth,
      },
      backgroundColor: themeBackground,
      borderBottom: `1px solid ${colors.border}`,
      boxShadow: 'none',
    },
    title: {
      flexGrow: 1,
      fontFamily: fontFamilies.display,
      fontWeight: 600,
      fontSize: '14px',
      color: colors.textPrimary,
      letterSpacing: '-0.01em',
    },
    menuButton: {
      color: colors.textSecondary,
      [theme.breakpoints.up('md')]: {
        display: 'none',
      },
    },
    toolbar: {
      minHeight: 60,
    },
    drawerPaper: {
      width: drawerWidth,
      backgroundColor: 'transparent',
      borderRight: 'none',
      // The menu list scrolls itself; the drawer never needs its own bar.
      overflowY: 'hidden',
    },
    content: {
      flexGrow: 1,
      height: '100%',
      minWidth: 0, // prevents flex children from overflowing
      display: 'flex',
      flexDirection: 'column',
    },
    body: {
      backgroundColor: colors.bgBody,
      padding: theme.spacing(3),
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
      [theme.breakpoints.only('xs')]: {
        padding: theme.spacing(1.5),
      },
      flex: 1,
      minHeight: 0,
      // Vertical scrolling only. Anything genuinely too wide (wide tables,
      // the timetable grid) carries its own overflowX:auto wrapper and still
      // scrolls inside itself — but the page shell no longer slides left and
      // right on a phone when one stray element overshoots the viewport.
      overflowY: 'auto',
      overflowX: 'hidden',
      borderRadius: 0,
      boxShadow: 'none',
    },
    // Desktop uses the PageHeader card; the app bar (and its spacer) only
    // remain below `md`, where they carry the menu button.
    appBarMobileOnly: { [theme.breakpoints.up('md')]: { display: 'none' } },
    toolbarMobileOnly: { [theme.breakpoints.up('md')]: { display: 'none' } },
    pageHeader: {
      padding: theme.spacing(3, 3, 0),
      backgroundColor: colors.bgBody,
      [theme.breakpoints.down('sm')]: { display: 'none' },
    },
    bodyPadded: {
      backgroundColor: colors.bgBody,
      padding: theme.spacing(3),
      [theme.breakpoints.down('sm')]: {
        padding: theme.spacing(2),
      },
      [theme.breakpoints.only('xs')]: {
        padding: theme.spacing(1.5),
      },
      flex: 1,
      minHeight: 0,
      // Vertical scrolling only. Anything genuinely too wide (wide tables,
      // the timetable grid) carries its own overflowX:auto wrapper and still
      // scrolls inside itself — but the page shell no longer slides left and
      // right on a phone when one stray element overshoots the viewport.
      overflowY: 'auto',
      overflowX: 'hidden',
      borderRadius: 0,
      boxShadow: 'none',
    },
    logoHolder: {
      flexGrow: 1,
    },
    menu: {
      color: colors.textSecondary,
    },
    drawerOpen: {
      width: drawerWidth,
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.enteringScreen,
      }),
    },
    drawerClose: {
      transition: theme.transitions.create('width', {
        easing: theme.transitions.easing.sharp,
        duration: theme.transitions.duration.leavingScreen,
      }),
      overflowX: 'hidden',
      width: theme.spacing(7) + 1,
      [theme.breakpoints.up('sm')]: {
        width: theme.spacing(9) + 1,
      },
    },
  }),
);
